import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchSectionList = createAsyncThunk(
	"fetchSectionList",
	async ({ page, filters, limit = 10 }) => {
		const keyword = filters && filters.keyword !== undefined ? `${filters.keyword}` : "";
		const departmentId = filters && filters.department !== undefined ? `${filters.department}` : "";

		const response = await axiosHttp.get(
			`section/list?page=${page}&limit=${limit}&keyword=${keyword}&department_id=${departmentId}`
		);

		return response.data.data;
	}
);

const sectionListSlice = createSlice({
	name: "sectionList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSectionList.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchSectionList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.current_page || 1;
			state.total = action.payload.total || 0;
		});
		builder.addCase(fetchSectionList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default sectionListSlice.reducer;
